export function countDecimals(value: number) {
  if (value % 1 != 0) return value.toString().split(".")[1].length;
  return 0;
}

export function roundNumber(value: number, decimals = 0) {
  const multiplier = Math.pow(10, decimals);
  return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
}
